<template lang="html">
    <form @submit.prevent="find()" class="form">
        <div class="form__items">
            <label class="form-item required">
                <span class="form-item__label">Номер заказа</span>
                <div class="default-input">
                    <input v-model="orderNum" v-keyboard.right.numeric inputmode="numeric" type="text" placeholder="Введите номер заказа" required />
                </div>
            </label>
            <label class="form-item required">
                <span class="form-item__label">Телефон</span>
                <div class="default-input">
                    <input-phone v-keyboard.right.phone v-model="phone" type="tel" ></input-phone>
                </div>
            </label>
            <label class="form-item">
                <XInputCheckbox
                    v-model="agreement"
                    :text="`Даю своё <a href='${policyLink}' target='_blank'>согласие на обработку персональных данных ООО «РК-Сервис»</a>`"
                    required
                />
            </label>
        </div>
        <div class="form__bottom">
            <button class="btn" type="submit">Проверить статус</button>
        </div>
    </form>

    <popup-block ref="findOrderResultPopup" v-slot="slotProps" type="right" >
        <div v-if="orderData.ACCOUNT_NUMBER" class="popup__title">
            <h2 class="popup__title-title">Заказ №{{ orderData.ACCOUNT_NUMBER }}</h2>
        </div>
        <div v-if="orderData.ID" class="os">
            <ul class="os__params">
                <li class="os__param"><span class="os__param-label">Дата заказа:</span><span class="os__param-value">{{ orderData.DATE_INSERT }}</span></li>
                <li class="os__param"><span class="os__param-label">Статус:</span><span class="os__param-value">{{ orderData.STATUS_NAME }}</span></li>
                <li class="os__param"><span class="os__param-label">Способ доставки:</span><span class="os__param-value">{{ orderData.DELIVERY_NAME }}</span></li>
                <li class="os__param"><span class="os__param-label">Сумма:</span><span class="os__param-value">{{ $filters.priceFormat(orderData.PRICE) }} ₽</span></li>
            </ul>
            <ul class="os__items">
                <li v-for="item in orderData.items" :key="item.ID" class="os__item">
                    <a :href="item.url" class="os__item-image">
                        <img v-if="item.imgSrc" :src="item.imgSrc" loading="lazy" />
                    </a>
                    <div class="os__item-info">
                        <a :href="item.url" class="os__item-name">{{ item.NAME }}, {{ item.QUANTITY }} шт.</a>
                        <span class="os__item-cost">{{ $filters.priceFormat(item.PRICE) }} ₽</span>
                    </div>
                </li>
            </ul>
            <div class="os__bot">
                <a class="btn" href="#" @click.prevent="slotProps.close(); orderNum = ''; $emit('reopen')">Посмотреть другой заказ</a>
            </div>
        </div>
    </popup-block>
</template>

<script>
import useInitData from '../composables/useInitData';
import { ref, watch } from 'vue';
import { findOrder } from '../api';
import XInputCheckbox from "@/components/inputs/XInputCheckbox.vue";

export default {
    name : 'CheckOrder',
    components: { XInputCheckbox },
    emits : [ 'reopen' ],
    props : {
      policyLink: String,
    },
    setup () {
        const initData = useInitData().data;
        const findOrderResultPopup = ref(null);
        const orderNum = ref('');
        const orderData = ref({});
        const phone = ref('');
		const agreement = ref(false);

        const find = () => {
			if (!agreement.value) {
				window.alert('Вы не дали согласие на обработку персональных данных')
				return;
			}
            findOrder({ orderNum : orderNum.value, phone : phone.value }).then(res => {
                if (res.message) {
                    alert(res.message);
                }
                if (res.data.ID) {
                    orderData.value = res.data;
                    findOrderResultPopup.value.open();
                }
            });
        }

        if (initData.value.PERSONAL_PHONE) {
            phone.value = initData.value.PERSONAL_PHONE.replace(/[^\d]/g, '');
        }
        watch(() => initData.value.PERSONAL_PHONE, () => {
            if (initData.value.PERSONAL_PHONE) {
                phone.value = initData.value.PERSONAL_PHONE.replace(/[^\d]/g, '');
            }
        });

        return {
            find,
            findOrderResultPopup,
            orderNum,
            orderData,
            phone,
            agreement,
        }
    }
}
</script>
